import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ScreeningService } from 'src/app/common-methods/services/screening.service';

@Component({
  selector: 'app-raise-query',
  templateUrl: './raise-query.component.html',
  styleUrls: ['./raise-query.component.css']
})
export class RaiseQueryComponent implements OnInit {
  @Input() mainForm: FormGroup;
  @Input() formgroupName: string;
  @Input() queryTypeList: any[] = [];
  @Input() responseDocTypeList: any[] = [];
  @Input() doctType: any[] = [];
  levelList: any[] = [];
  maxdate = new Date();

  constructor(private screeningService: ScreeningService) { }

  ngOnInit() {
    this.screeningService.getInsuffDetails(false).subscribe(res => {
      if (res) {
        // Raise Query only ever needs "Level-2" - no stable frontend lookup-id constant exists for
        // it, so filter the shared insufficiency-level list by name (mirrors InsuffConstants.LevelTwo
        // server-side). Only default-select it when nothing is already set, so a reload pre-fill
        // (screening-details.component.ts's screeningQuery.patchValue) isn't overwritten.
        this.levelList = (res.insuffLevel || []).filter(l => l.lookUpName === 'Level-2');
        const levelLookupIdCtrl = this.mainForm.get(this.formgroupName).get('levelLookupId');
        if (this.levelList.length && !levelLookupIdCtrl.value) {
          levelLookupIdCtrl.setValue(this.levelList[0].lookUpId);
        }
      }
    });
  }
}
